import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const BD100HeroWrapper = styled.div`
  width: 100%;
  min-height: 291px;

  position: relative;
  display: flex;
  flex-direction: column;

  background-image: url('/images/bd100/bd_100_header.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export const BD100HeroContent = styled.div`
  max-width: 1440px;
  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 60px 50px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(31, 32, 37, 0.45);
    backdrop-filter: blur(5.5px);
  }

  ${BREAKPOINTS.tablet} {
    padding: 60px 20px;
  }

  margin: 0 auto;
`;

export const BD100HeroTitle = styled.h1`
  font-size: 64px;
  font-weight: 400;
  color: #fff;

  z-index: 1;
`;

export const BD100HeroDescription = styled.p`
  font-size: 24px;
  font-weight: 400;
  color: #fff;

  z-index: 1;
`;
